import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import ScrollToBottom from 'react-scroll-to-bottom';
import { Col, Row, Button } from 'reactstrap';
import socketIOClient from 'socket.io-client';
import CustomModal from '../../../../CustomModal';
import CustomSelection from '../../../../CustomSelection';
import AddSecurityCodeModal from '../../../../AddSecurityCodeModal';
import logoLoading from '../../../../../Res/logo-loading.gif';
import {
  checkWatchguardIsActive,
  fetchDiagnosticReport,
  refreshDiagnosticResults,
  restartWatchguard,
} from '../../../../../actions/EpikBoxes';
import { dataCenterShellUrls } from '../../../BoxOverview';
import fetchLogo from '../../../../../Res/Icon/Fetch-Results.svg'
import vSwitchLogo from '../../../../../Res/Icon/vSwitch-Output-new.svg'

import runDiagnosticLogo  from '../../../../../Res/Icon/arrow-down-to-line-solid.svg'
import recButtonLogo from '../../../../../Res/Icon/REC-Button.svg'
import TooltipIcon from '../../TooltipIcon/TooltipIcon';
import XmlViewer from '../../../../xmlViewer';
import { ReactComponent as LoadingIcon} from '../../../../../Res/loadingSpinner.svg';

const Diagnostics = ({ boxDetails, user }) => {
  const token = localStorage.getItem('jwtToken') || null;

  const dispatch = useDispatch();

  const [diagRes, setDiagRes] = useState([]);
  const [fetchTest, setFetchTest] = useState(false);
  const [watchguardCheck, setWatchguardCheck] = useState(false);
  const [stateSocket, setStateSocket] = useState(null);
  const [rceModal, setRceModal] = useState(false);
  const [commandList, setCommandList] = useState([]);
  const [selectedDiscription, setSelectedDiscription] = useState('');
  const [selectedCommand, setSelectedCommand] = useState('');
  const [commandDataList, setCommandDataList] = useState([]);
  const [recMoreOptions, setRecMoreOptions] = useState([]);
  const [recSubCommand, setRecSubCommand] = useState('');
  const [modalStatus, setModalStatus] = useState(false);
  const [isFsCli, setIsFsCli] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [noDiagLogs, setnoDiagLogs] = useState('No diagnostics logs found!');
  const messageRef = useRef();
  const serialNumberDash = `${boxDetails.serialNumber}-${user._id}`;

  useEffect(() => {
    if (messageRef.current) {
      messageRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    }
  });

  useEffect(() => {
    const request = async () => {
      if (isFsCli !== null) {
        await rceRequest(isFsCli);
        console.log("connection request placed")
      }
    }
    request()
  }, [isFsCli])

  const rceRequest = async () => {
    // const serialNumberDash = isFsCli ? serialNumberDashVSwitch : serialNumberDash
    // console.log('selectedCommand', isFsCli, serialNumberDash);
    const baseUrl = dataCenterShellUrls[boxDetails.datacenter];
    const socket = socketIOClient.connect(baseUrl, { query: { token } });
    socket.on('connect', async () => {
      socket.emit('RCE', {
        serialNumber: serialNumberDash,
        command: 'getList',
        ip: boxDetails.vpnAddress,
      });
      setStateSocket(socket);
      await new Promise(resolve => {
        socket.on(`rce-${serialNumberDash}-list`, data => {
          if (data.commands.length > 0) {
            setCommandList(data.commands);
            setRecMoreOptions([]);
            if (modalStatus) {
              setSelectedCommand(data.commands[0]);
              setSelectedDiscription(data.commands[0].description);
              setModalStatus(false);
              setRceModal(true);
            }
            resolve();
          }
        });
      });
      if (isFsCli) {
        onRunCommand(
          { name: 'active_call_monitoring', description: 'Active Call Monitoring' },
          socket,
        );
      }
    });
  };

  const rceDataRequest = (socket) => {
  // let command = recMoreOptions.length ? recSubCommand : selectedCommand;
  // const serialNumberDash = isFsCli ? serialNumberDashVSwitch : serialNumberDash
  // let ssocket = socket ? socket : stateSocket


    const ssocket = socket ? socket : stateSocket;
    if (!ssocket) console.log("socket instance error ")

    ssocket && ssocket.on(`rce-${serialNumberDash}-command`, data => {
      const command = recMoreOptions.length ? recSubCommand : selectedCommand;
      // console.log('selectedCommand fsCli ', isFsCli, command)
      // const commandData = commandDataList?.length > 0 || command?.name != 'active_call_monitoring' ? commandDataList : [];
      const commandData = [...commandDataList];
      // if (command?.name === data.command || isFsCli) {
      // console.log(`${isFsCli ? 'fscli is true' : 'selectedCommand command matched '}`, command?.name, data.command, isFsCli)
        commandData.push(data.output);
      setCommandDataList(commandData);
      // } else {
      // console.log("*********response********* selectedCommand  unhandled response ", command?.name, data.command, data.output)
      // }
    });
  };

  const onRunCommand = () => {
  // const serialNumberDash = isFsCli ? serialNumberDashVSwitch : serialNumberDash

    let command = recMoreOptions.length ? recSubCommand : selectedCommand;
    console.log({ command })
    let ssocket = stateSocket;
    if (command) {
      ssocket.emit('RCE', {
        serialNumber: serialNumberDash,
        command: command,
        ip: boxDetails.vpnAddress,
        rec: true
      });
      setTimeout(() => {
        rceDataRequest(ssocket);
      }, 100)
    }
  };

  const onCommandListChange = e => {
    const { value } = e.target;
    const index = commandList.findIndex(x => x.name === value); // Selected Command index
    const selectedItem = commandList[index]; // Selected Command Item
    let command = typeof selectedCommand === 'object' ? { ...selectedCommand } : {}
    command = { ...command, ...selectedItem }
    // setSelectedCommand(selectedItem);
    setSelectedCommand(command);
    if (selectedItem.moreOptions) {
      setRecMoreOptions(selectedItem.moreOptions);
      setRecSubCommand(selectedItem.moreOptions[0]);
      setSelectedDiscription(selectedItem.moreOptions[0].description);
    } else {
      setSelectedDiscription(selectedItem.description);
      setRecMoreOptions([]);
    }
  };
  const onRecSubCommandChange = e => {
    const { value } = e.target;
    const index = recMoreOptions.findIndex(x => x.name === value); // Selected Command index
    const selectedItem = recMoreOptions[index]; // Selected Command Item
    setSelectedDiscription(selectedItem.description);
    setRecSubCommand(selectedItem);
  };
  const onClearRce = () => {
    setCommandDataList([]);
  };
  const renderCommandList = (
    <>
      <h1>Command</h1>
      <div className="header-rce">
        <CustomSelection onChange={onCommandListChange} filterBy="name" optionsList={commandList} />
        {recMoreOptions?.length ? (
          <CustomSelection
            onChange={onRecSubCommandChange}
            filterBy="name"
            optionsList={recMoreOptions}
          />
        ) : null}
        <div className="command-text-container">
          <h1 className="command-list-text">{selectedDiscription}</h1>
        </div>
      </div>
    </>
  );

  const renderRunCommand = (
    <Button color="primary" onClick={() => onRunCommand()}>
      Execute
    </Button>
  );

  const onConfirmRce = () => {
    // onRceDiagnostics();
    setIsFsCli(false)
    // setModalStatus(false);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const { _id } = boxDetails;
      const report = await dispatch(fetchDiagnosticReport(token, _id));
      const watchGuard = await dispatch(checkWatchguardIsActive(token, _id));

      setWatchguardCheck(watchGuard);
      setIsLoading(false);

      if (Array.isArray(report)) setDiagRes(report);
      else setnoDiagLogs(report);
    })();
  }, [fetchTest]);

  const onFetchResults = async () => {
    setFetchTest(!fetchTest);
  };

  const onRefreshResults = async () => {
    (async () => {
      setIsLoading(true);
      const { _id } = boxDetails;
      await dispatch(refreshDiagnosticResults(token, _id));
      setIsLoading(false);
    })();
  };
  const setRecOff = () => {
    // const serialNumberDash = isFsCli ? serialNumberDashVSwitch : serialNumberDash
    stateSocket.emit('RCE', {
      serialNumber: serialNumberDash,
      ip: boxDetails.vpnAddress,
      cleanup: true,
    });
    setIsFsCli(null);
    setCommandDataList([]);
    setRceModal(false);
  };
  const onRestartWatchguard = async () => {
    (async () => {
      setIsLoading(true);
      const { _id } = boxDetails;
      const restarted = await dispatch(restartWatchguard(token, _id));

      if (restarted) {
        setWatchguardCheck('active');
      } else {
        setWatchguardCheck(restarted);
      }
      setIsLoading(false);
    })();
  };

  return isLoading ? (
    <div className="error-msg d-flex flex-column justify-content-center align-items-center">
      <img src={logoLoading} className="loading-logo-sm" alt="loading" />
      <p className="text-align-center">Loading, Please wait...</p>
    </div>
  ) : (
    <div className=" ">
      <Row >
      <ScrollToBottom className="diagnostics-data-container">
        <Row>
          <Col md={12} ref={messageRef}>
            {Array.isArray(diagRes) &&
              diagRes.length > 0 &&
              diagRes?.map(item => {
                const lastResult = item.value.trimStart();
                return (
                  <Row
                    className={item?.key === 'Timestamp' ? 'list-item timestamp-head' : 'list-item'}
                    style={{
                      backgroundColor:
                        (lastResult === 'PASS' && '#008000') ||
                        (lastResult === 'PASS (After fix attempt)' && '#90EE90') ||
                        (lastResult === 'FAIL' && '#FFFF00') ||
                        (lastResult === 'FAIL (After fix attempt)' && '#FF0000') ||
                        (lastResult === 'fixed' && '#008000') ||
                        (lastResult === 'running' && '#ADD8E6'),
                    }}
                  >
                    <Col md={item?.key === 'Timestamp' ? 7 : 12} className="right-container">
                      <h1
                        style={{
                          color: lastResult === 'failed' && '#FFFFFF',
                          alignSelf: 'center',
                        }}
                      >
                        {`${item.key} : ${lastResult}`}
                      </h1>
                    </Col>
                    {item?.key === 'Timestamp' ? (
                      <Col md={item?.key === 'Timestamp' ? 5 : 0} className="right-container">
                        {watchguardCheck === 'active' ? (
                          'Diagnostics Service Running'
                        ) : (
                          <Button
                            color="danger"
                            className="fetch-tests"
                            onClick={() => onRestartWatchguard()}
                          >
                            Restart Diagnostics Service
                          </Button>
                        )}
                      </Col>
                    ) : (
                      ''
                    )}
                  </Row>
                );
              })}
            {(!Array.isArray(diagRes) || diagRes.length === 0) && (
              <>
                <Row className="list-item timestamp-head">
                  <Col md={7} className="right-container" />
                  <Col md={5} className="right-container">
                    {watchguardCheck === 'active' ? (
                      'Diagnostics Service Running'
                    ) : (
                      <Button
                        color="danger"
                        className="fetch-tests"
                        onClick={() => onRestartWatchguard()}
                      >
                        Restart Diagnostics Service
                      </Button>
                    )}
                  </Col>
                </Row>
                <div className="diagnostic-no-logs">
                  <h1>{noDiagLogs || 'No Data Found'}</h1>
                </div>
              </>
            )}
          </Col>
        </Row>
      </ScrollToBottom>
      </Row>
      <div className='row'>
          <div class="connectionButtonsContainer">
           
           
            <div className={`col-md-3 `} >
            <span style={{ 'padding-right': '50px' }}>
            <TooltipIcon
              tipId="add-time-icons"
              onClick={() => {
                setModalStatus(true);
              }}
              imgSrc={recButtonLogo}
              displayData="Remote Execution Center"
              placement="top"
            />
            </span>

            <TooltipIcon
              tipId="add-time-iconssss"
              onClick={() => {
                setIsFsCli(true);
                setModalStatus(true)
              }}
              imgSrc={vSwitchLogo}
              displayData="vSwitch Output"
              placement="top"
              />
            </div>
           
            <div className={`col-md-6 `} >  </div>
          
          <div className={`col-md-3 `} >
          <span style={{ 'padding-right': '50px' }}>
            <TooltipIcon
              tipId="add-time-iconsss"
              onClick={() => {
                onFetchResults();
              }}
              imgSrc={runDiagnosticLogo}
              displayData="Download Results"
              placement="top"
            />
            </span>
           
           <TooltipIcon
              tipId="add-time-icon"
              onClick={() => {
                onRefreshResults();
              }}
              imgSrc={fetchLogo}
              displayData="Query Device for Real-Time Details"
              placement="top"
              />
            </div>
        </div>

      </div>


      <CustomModal
        header={isFsCli ? null : renderCommandList}
        isOpen={rceModal}
        closeHeader={isFsCli ? null : renderRunCommand}
        onCancel={setRecOff}
        wider
      >
          {commandDataList?.length > 0 ? (
          <>
              {commandDataList.map((item = '') => {
              const str = item.toString()
              const xml = str.search('<include>') !== -1;
              return xml ? <XmlViewer xml={item} /> : <p dangerouslySetInnerHTML={{ __html: item.split('\\n').join('<br />') }}></p>;
            })}
            <Button color="primary" onClick={onClearRce}>
              Clear data
            </Button>
          </>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {/* <h1>No Data Found saads</h1> */}
            <LoadingIcon width={50} height={50} />
          </div>
        )}
      </CustomModal>

      <AddSecurityCodeModal
          isOpen={modalStatus && !isFsCli}
        onCancel={() => {
          setModalStatus(!modalStatus);
          setIsFsCli(false);
        }}
        onConfirm={onConfirmRce}
        rceSecurity
        featureName={'rceSecurity'}
      />
    </div>
  );
};

export default Diagnostics;
